module.exports = __webpack_public_path__ + "img/9788952211415.02125264.jpg";